import React from 'react';

import { useGeneralSurveyStatusUpdate } from '@occc-app/dataAccessLayer/survey/mutations';
import { GeneralSurveyStatusUpdateMutationOptions, SurveyStatus } from '@occc/graphql';
import { snackbar } from '@occc-app/design-system';

import { messages } from '../messages';

type UseActivateGeneralSurveyProps = {
  onCompleted?: () => void;
  refetchQueries?: GeneralSurveyStatusUpdateMutationOptions['refetchQueries'];
};

export const useActivateGeneralSurvey = ({
  onCompleted,
  refetchQueries,
}: UseActivateGeneralSurveyProps) => {
  const onActivateError = React.useCallback(() => {
    snackbar.error(messages.activateError);
  }, []);

  const onActivateCompleted = React.useCallback(() => {
    snackbar.success(messages.activateSuccess);
    onCompleted?.();
  }, [onCompleted]);

  const [updateGeneralSurveyStatus, { loading }] = useGeneralSurveyStatusUpdate({
    onCompleted: onActivateCompleted,
    onError: onActivateError,
    refetchQueries,
  });

  const activateSurvey = React.useCallback(
    (surveyUuid: string) => {
      updateGeneralSurveyStatus({
        variables: {
          input: {
            uuid: surveyUuid,
            status: SurveyStatus.Active,
          },
        },
      });
    },
    [updateGeneralSurveyStatus],
  );

  return [activateSurvey, loading] as const;
};
